var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"contents"}},[(_vm.componentEnabled)?_vm._t("default",null,{"attachGet":_vm.getPopperEl,"menuProps":{
            transition: 'popper-scale-vertical',
            contentClass: 'menu-rounded menu-max-width-screen'
        }}):_vm._e(),_vm._v(" "),_c('portal',{attrs:{"selector":"#app"}},[_c('div',_vm._g(_vm._b({ref:"popper",staticClass:"popper-menu-anchor",class:{'popper-menu-hide-under-navbar': !_vm.popupUsedInModal}},'div',_vm.$attrs,false),_vm.$listeners))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }